export const convertToGeoJson = (data: any[]): GeoJSON.FeatureCollection => {
  return {
    type: 'FeatureCollection',
    features: data.map((item: any) => {
      const { coordinates, type, ...properties } = item;

      return {
        type: 'Feature',
        geometry: {
          type,
          coordinates
        },
        ...properties
      };
    })
  };
};
